import { AuviousCommon } from "@auvious/common";
import { Timers } from "@auvious/utils";
import { AppConfigService as Config } from "./app.config.service";
import { getAssetPath } from "@stencil/core";
import { Log } from "./log.service";

// use as a backup in case auvious common is not initialised
class DefaultTimers {
  setTimeout(callback: Function, delay) {
    return setTimeout(callback, delay);
  }

  clearTimeout(id) {
    return clearTimeout(id);
  }

  setInterval(callback: Function, interval) {
    return setInterval(callback, interval);
  }

  clearInterval(id) {
    return clearInterval(id);
  }
}

class CommonServiceCtrl {

  private _defaultTimers;
  private _commonTimers: Timers;

  constructor() {
    this._defaultTimers = new DefaultTimers();
  }

  async initTimers() {
    const assetsLocation = getAssetPath("auvious-assets");
    this._commonTimers = new Timers(assetsLocation);
    await this._commonTimers.init();
  }

  async createInstance() {
    const assetsLocation = getAssetPath("auvious-assets");
    const client = new AuviousCommon({
      /** should point to the proxy server */
      serverUrl: Config.auviousBaseUrl,
      /** remote server, thanks to which we can share remote pages in this setup */
      mqttUrl: `wss://${Config.auviousWebSocketUrl}/ws`,
      saveAuthTokenState: false,
      useStandardOAuth2: true,
      eventServerJwtOn: true,
      assetsLocation,
      timers: this._commonTimers,
    });
    return client;
  }

  get timer(): Timers {
    return this._commonTimers || this._defaultTimers;
  }

  async logout(client: AuviousCommon) {
    try {
      await client.events.disconnect();
    } catch (error) {
      Log.debug("error on events disconnect", error);
    }
    try {
      await client.auth.logout();
    } catch (error) {
      Log.debug("error on auth logout", error);
    }
  }
}

export const CommonService = new CommonServiceCtrl();
